import React, { useMemo } from "react";

import { BoxProps, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, } from "@chakra-ui/react";
import APButton from "../APButton";
import APIconButton from "../APIconButton";
import { Close } from "../APAssetAtlas";
import { useVocabIntl } from "../../hooks/useVocabTranslation";

interface APCommonDialogProp {
  children: any;
  open: boolean;
  title: string | React.ReactNode;
  onNext?: any;
  onClose: () => void;
  error: boolean;
  btnLoading?: boolean;
  btnTitle?: string;
  footer?: React.ReactNode;
  footerJustifyContent?: BoxProps["justifyContent"];
  btnTabIndex?: number;
  preventCloseOnEsc?: boolean;
}

function APCommonDialog({
                          children,
                          open,
                          title,
                          onNext,
                          onClose,
                          error,
                          btnLoading,
                          btnTitle,
                          footer,
                          footerJustifyContent,
                          btnTabIndex,
                          preventCloseOnEsc
                        }: APCommonDialogProp) {
  const { getFormattedString, APFormattedMessage } = useVocabIntl()
  const onContinue = () => {
    onNext();
  };

  const renderFooter = useMemo(() => {
    if (footer) {
      return footer;
    } else {
      if (error) {
        return (
          <APButton
            colorScheme={"alert"}
            onClick={() => onContinue()}
            isLoading={btnLoading}
            tabIndex={btnTabIndex}
            aria-label={getFormattedString('aria-label-quit-button')}>
            {btnTitle || <APFormattedMessage id={'quit-button'}></APFormattedMessage>}
          </APButton>
        );
      } else {
        return (
          <APButton
            onClick={() => onContinue()}
            aria-label={btnTitle || "Suivant"}
            tabIndex={btnTabIndex}>
            {btnTitle ? btnTitle : "Suivant"}
          </APButton>
        );
      }
    }
  }, [footer, onContinue, btnTitle]);

  return (
    <Modal blockScrollOnMount={false} closeOnOverlayClick={false} isOpen={open} onClose={onClose}
           closeOnEsc={!preventCloseOnEsc} size={"md"}>
      <ModalOverlay>
        <ModalContent>
          <ModalHeader textAlign={"center"}>
            {title}
          </ModalHeader>

          <APIconButton variant={"raisedIcon"} rounded={"full"} tabIndex={3} onClick={onClose}
                        position={"absolute"} right={"-0.75rem"} top={"-0.75rem"} fontSize={"1.5rem"}
                        aria-label={getFormattedString('aria-label-close-modal')}>
            <Close />
          </APIconButton>

          <ModalBody>
            {children}
          </ModalBody>

          <ModalFooter display={"flex"} justifyContent={footerJustifyContent ?? "center"}>
            {renderFooter}
          </ModalFooter>

        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}

export default APCommonDialog;
